import { Currencies } from "@/constants/currency";

export function formatCurrency(currency: Currencies): string {
  switch (currency) {
    case "GBP":
      return "GBP";
    case "EUR":
      return "EUR";
    case "USD":
      return "USD";
    case "CHF":
      return "CHF";
    default:
      return "CHF";
  }
}
